

function Notice() {
    return (
        <div>
            <h1>Notice</h1>
            <p>
Notice: *** YYou can find the source code for this project at:
                <a href="https://github.com/lewislwood/nfbcs-vscode-presentation">//github.com/lewislwood/nfbcs-vscode-presentation</a><div className=""></div><br/>
                **** See resources and links below for more information..
            </p>

        </div>

    )
}export default Notice;
